<template>
	<div class="flex flex-wrap gap-2">
		<AppPill icon="info">Versie {{ versionNumber }}</AppPill>
		<AppPill v-if="isRevision" icon="history_edu">Revisie</AppPill>
		<AppPill v-else icon="history_edu">Concept</AppPill>
		<AppPill v-if="hasUnsavedChanges">
			<AppIcon name="progress_activity" class="animate-spin"></AppIcon>
			Opslaan...
		</AppPill>
		<AppPill v-else icon="save">Opgeslagen</AppPill>
	</div>
</template>

<script lang="ts" setup>
interface Props {
	isRevision: boolean;
	hasUnsavedChanges: boolean;
	versionNumber: number;
}
defineProps<Props>();
</script>
